module.exports = __webpack_public_path__ + "img/auto_spin_btn.835bd1dc.png";